export default __webpack_public_path__ + "static/media/seanor_white_logo.ca5ba098.svg";